import { Input } from "design-react-kit";
import { useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { TokenContext } from "../../Components/TokenContext";
import { isSelectQuery, SELECT_QUERY_ERROR } from "../../Utility/reportQuery";

function NewReport(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [queryError, setQueryError] = useState("");
  const [apiError, setApiError] = useState("");
  const [data, setData] = useState({
    title: "",
    description: "",
    query: "",
  });

  const newReportValidation = () => {
    setValidation(true);
    setApiError("");
    let ok = true;
    if (!data.title) ok = false;
    if (!data.description) ok = false;
    if (!data.query) {
      ok = false;
      setQueryError("Il campo non può essere vuoto!");
    } else if (!isSelectQuery(data.query)) {
      ok = false;
      setQueryError(SELECT_QUERY_ERROR);
    } else {
      setQueryError("");
    }
    if (ok) toggleModal(!isOpen);
  };

  const insertReportAPI = () => {
    Repo.postInsertReport(apiToken, JSON.stringify(data))
      .then(() => {
        window.location.href = props.subfolder + "/report";
      })
      .catch((error) => {
        console.log(error);
        setApiError(
          error.response?.data?.Message ||
            error.response?.data?.message ||
            SELECT_QUERY_ERROR
        );
      });
  };

  return (
    <div>
      <h1>Nuovo report</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Inserisci un nuovo report indicando titolo, descrizione e la query SQL
          da eseguire. Sono ammesse solo query di tipo SELECT.
        </p>
      </div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <Input
            id="title"
            required
            label="Titolo*"
            type="text"
            name="title"
            value={data.title}
            {...(validation &&
              !data.title && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, title: e.target.value })}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12">
          <Input
            id="description"
            required
            label="Descrizione*"
            type="text"
            name="description"
            value={data.description}
            {...(validation &&
              !data.description && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, description: e.target.value })}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12">
          <label htmlFor="query">Query*</label>
          <textarea
            id="query"
            name="query"
            className={`form-control${
              validation && queryError ? " is-invalid" : ""
            }`}
            rows={12}
            value={data.query}
            onChange={(e) => {
              setQueryError("");
              setData({ ...data, query: e.target.value });
            }}
          />
          {validation && queryError && (
            <small className="text-danger">{queryError}</small>
          )}
        </div>
      </div>

      {apiError && (
        <div className="alert alert-danger mt-2" role="alert">
          <b>{apiError}</b>
        </div>
      )}

      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={newReportValidation}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo report"
        body="Confermi di voler inserire un nuovo report?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={insertReportAPI}
      />
    </div>
  );
}

export default NewReport;
